var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"inner"},[_vm._t("sidebar"),_c('div',{staticClass:"main",class:_vm.isAdmin ? 'admin' : ''},[_vm._t("main")],2)],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }